// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.

import { sortBy } from 'lodash'
import { createSelector } from 'reselect'

import { fullFileStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../index').FileCategories} Categories
 * @typedef {import('../index').Category} Category
 */

/**
 * @type {function(PlottrState): Categories}
 */
export const allCategoriesSelector = createSelector(
  fullFileStateSelector,
  ({ categories }) => categories ?? {}
)
/**
 * @type {function(PlottrState): Array<Category>}
 */
export const characterCategoriesSelector = createSelector(
  allCategoriesSelector,
  ({ characters }) => characters ?? []
)
/**
 * @type {function(PlottrState): Array<Category>}
 */
export const noteCategoriesSelector = createSelector(
  allCategoriesSelector,
  ({ notes }) => notes ?? []
)
/**
 * @type {function(PlottrState): Array<Category>}
 */
export const tagCategoriesSelector = createSelector(allCategoriesSelector, ({ tags }) => tags ?? [])
/**
 * @type {function(PlottrState): Array<Category>}
 */
export const placeCategoriesSelector = createSelector(
  allCategoriesSelector,
  ({ places }) => places ?? []
)

/**
 * @param {PlottrState} _state
 * @param {keyof Categories} type
 */
const typeSelector = (_state, type) => {
  return type
}
/**
 * @type {function(PlottrState, string): Array<Category>}
 */
export const categoryByTypeSelector = createSelector(
  allCategoriesSelector,
  typeSelector,
  (categories, categoryType) => {
    return categories[categoryType] ?? []
  }
)

/**
 * @type {function(PlottrState): Array<Category>}
 */
export const sortedCharacterCategoriesSelector = createSelector(
  characterCategoriesSelector,
  (categories) => sortBy(categories, 'position')
)

/**
 * @type {function(PlottrState): Array<Category>}
 */
export const sortedNoteCategoriesSelector = createSelector(noteCategoriesSelector, (categories) =>
  sortBy(categories, 'position')
)

/**
 * @type {function(PlottrState): Array<Category>}
 */
export const sortedTagCategoriesSelector = createSelector(tagCategoriesSelector, (categories) =>
  sortBy(categories, 'position')
)

/**
 * @type {function(PlottrState): Array<Category>}
 */
export const sortedPlaceCategoriesSelector = createSelector(placeCategoriesSelector, (categories) =>
  sortBy(categories, 'position')
)
